__turbopack_context__.v({
  "cardRoot": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__cardRoot",
  "detailsColumn": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__detailsColumn",
  "imageColumn": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__imageColumn",
  "priceWrapper": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__priceWrapper",
  "promotedLabel": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__promotedLabel",
  "scale-in-left": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__scale-in-left",
  "urgencySignals": "OrganizerHorizontalEventCard-module-scss-module__mJtSdW__urgencySignals",
});
